import { LOGIN_SUCCESS,SET_JOB_SCHEDULE,SET_DATA_TYPE, LOGOUT, SET_SELECTED_ROLE, SET_CONFIGURATION_LIST, SET_FILTER_LIST, SET_PROVISION_TYPE } from "../../common/actionTypes";
const INITIAL_STATE = {
  user: {
    id: null,
  },
  configurationList: [],
  filterlist:{},
  datatype:{},
  jobschedule:{}
};


const authReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return { ...state, user: action.payload };
    }
    case LOGOUT: {
      return { ...INITIAL_STATE };
    }
    case SET_SELECTED_ROLE: {
      return {...state, selectedRole: action.payload};
    }
    case SET_CONFIGURATION_LIST: {
      return {...state, configurationList: action.payload};
    }
    case SET_FILTER_LIST: {
      return {...state, filterlist: action.payload};
    }
    case SET_DATA_TYPE:{
      return{...state,datatype:action.payload}
    }
    case SET_JOB_SCHEDULE:{
      return{...state,jobschedule:action.payload}
    }
    case SET_PROVISION_TYPE:{
      return{...state,provisiontype:action.payload}
    }
    default:
      return state;
  }
};

export default authReducer;
